import React from "react";

/**
 * DisplayButton - A reusable component for displaying buttons with null/blank value checking
 * @param {Array} buttons - Array of button JSX elements (React elements)
 */
const DisplayButton = ({ buttons = [] }) => {
    // Filter out null, undefined, and blank values
    const validButtons = buttons.filter((button) => {
        // Filter out null and undefined
        if (button === null || button === undefined) return false;

        // Filter out empty strings
        if (typeof button === "string" && button.trim() === "") return false;

        // Filter out false (common for conditional rendering)
        if (button === false) return false;

        // For React elements, check if it's a valid element
        if (React.isValidElement(button)) {
            return true;
        }

        return false;
    });

    // If no valid buttons, return null
    if (validButtons.length === 0) {
        return null;
    }

    return (
        <div className="flex_col g4 justify-content_between align-items_end xpert-align-self-stretch">
            <hr className="justify-content_center align-items_center xpert-align-self-stretch"></hr>
            <div className="flex flex_col_mobile g1_mobile g4 align-items_start_mobile align-items_center xpert-align-self-stretch justify-content_center_mobile justify-content_between">
                {validButtons.map((button, index) => {
                    // Skip if button is null/undefined/false/blank
                    if (!button || button === null || button === undefined || button === false) {
                        return null;
                    }

                    // Render the button element directly (it already includes its wrapper div if needed)
                    return (
                        <React.Fragment key={button.key || index}>
                            <div className="flex g4 align-items_center xpert-align-self-stretch justify-content_end">
                                {button}
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default DisplayButton;

